import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        routerInfo: {
            name: "登录", path: "/", routeMenu: []
        }, eventInfo: null, routeInfo: {list: []}, userLogin: false, userInfo: null, screenWidth: 0, screenHeight: 0,
    }, mutations: {
        setRouterInfo(state, routerInfo) {
            state.routerInfo = routerInfo
        }, setEventInfo(state, eventInfo) {
            state.eventInfo = eventInfo
        }, setUserLogin(state, userLogin) {
            state.userLogin = userLogin
        }, setUserInfo(state, userInfo) {
            state.userInfo = userInfo
        }, setScreenWidth(state, screenWidth) {
            state.screenWidth = screenWidth
        }, setScreenHeight(state, screenHeight) {
            state.screenHeight = screenHeight
        }, clearRoute: (state) => {
            state.routeInfo = {
                list: [{
                    name: "首页", path: "/home"
                }], current: "/home"
            }
        }, setRoute: (state, info) => {
            state.routeInfo = info
        }, updateRoute: (state, to) => {
            if (state.routeInfo.list === undefined) {
                state.routeInfo.list = []
            }
            if (to.meta.cache === false) {
                return
            }
            if (state.routeInfo.list.filter(a => {
                return a.path === to.fullPath
            }).length > 0) {
                state.routeInfo.current = to.fullPath
            } else {
                state.routeInfo.current = to.fullPath
                if (state.isMobile) {
                    state.routeInfo.list = [{
                        name: "首页", path: "/home"
                    }, {
                        name: to.name, path: to.fullPath
                    }]
                } else {
                    state.routeInfo.list.push({
                        name: to.name, path: to.fullPath
                    })
                }
            }
        }, closeRoute: (state, path) => {
            state.routeInfo.list = state.routeInfo.list.filter(a => {
                return a.path !== path
            })
        }
    }, actions: {
        setEventInfo(context, eventInfo) {
            context.commit("setEventInfo", eventInfo)
        }, setRouterInfo(context, routerInfo) {
            context.commit("setRouterInfo", routerInfo)
        }, setRoute: (context, info) => {
            context.commit("setRoute", info)
        }, clearRoute: (context) => {
            context.commit("clearRoute")
        }, updateRoute: (context, to) => {
            context.commit("updateRoute", to)
        }, closeRoute: (context, path) => {
            context.commit("closeRoute", path)
        }, setUserLogin(context, userLogin) {
            context.commit('setUserLogin', userLogin)
        }, setUserInfo(context, userInfo) {
            context.commit('setUserInfo', userInfo)
        }, setScreenWidth(context, screenWidth) {
            context.commit('setScreenWidth', screenWidth)
        }, setScreenHeight(context, screenHeight) {
            context.commit('setScreenHeight', screenHeight)
        }
    }, modules: {}
})
